import { css } from '@emotion/react';
import { type FC } from 'react';
import { LinkComponent } from '~/_shared/baseComponents/links';
import {
  MAPTIVE_PRIVACY_POLICY, MAPTIVE_TERMS_OF_SERVICE,
} from '~/_shared/constants/maptive';
import {
  s, Trans,
} from '~/translations/Trans';
import { type Translations } from '~/translations/translations.type';

const linkStyle = css({
  fontSize: 'inherit',
});

// 'explicit' is worded as an agreement the user actively gives (used next to a checkbox),
// 'implicit' as an agreement given by proceeding with the sign up (used without a checkbox)
export type TermsAndPrivacyConsentType = 'explicit' | 'implicit';

const consentTypeTranslationIds = {
  explicit: 'signup.agreement',
  implicit: 'signup.agreement.byProceeding',
} as const satisfies Record<TermsAndPrivacyConsentType, keyof Translations>;

type TermsAndPrivacyNoticeProps = {
  className?: string;
  consentType?: TermsAndPrivacyConsentType;
};

export const TermsAndPrivacyNoticeComponent: FC<TermsAndPrivacyNoticeProps> = ({ className, consentType = 'explicit' }) => {
  return (
    <div className={className}>
      <Trans i18nKey={consentTypeTranslationIds[consentType]}>
        {s('prefix')}
        <LinkComponent
          css={linkStyle}
          path={MAPTIVE_TERMS_OF_SERVICE}
          target="_blank"
        >
          {s('termsOfService')}
        </LinkComponent>
        {s('separator')}
        <LinkComponent
          css={linkStyle}
          path={MAPTIVE_PRIVACY_POLICY}
          target="_blank"
        >
          {s('privacyPolicy')}
        </LinkComponent>
        {s('suffix')}
      </Trans>
    </div>
  );
};
